import { createApiHooks } from '@apis/next/common';
import { WorkdayPostBody } from '@models/next/Workday';
import { z } from 'zod';

export const workdayApis = createApiHooks('/workday', [
  {
    method: 'post',
    path: '/',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: WorkdayPostBody,
      },
    ],
    response: z.string().array(),
  },
]);
